//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { ERC20Wei } from '@shared/conversions'

import { PoolControllerAbi } from '@shared/Abis'
import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'
import { UserConnection } from '@shared/DeploymentConfigTypes'

export const withdrawFeesTx =
  (props: { poolAddr: EthAddr; assets: ERC20Wei }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<any> => {
    const activity = ActivityEnum.WITHDRAW_FEES

    try {
      const { webSocket } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration

      const { roleEnum, signer } = getState().chainState.userConnection as UserConnection
      assertRole(roleEnum, RoleEnum.POOL_ADMIN)
      const { poolAddr, assets } = props
      const poolOverviewCTO = getState().poolState.poolOverviewCTOs[poolAddr]

      const poolControllerAddr = poolOverviewCTO.poolControllerAddr
      logOT.debug('withdrawFeesSaga', poolAddr)
      await withdrawFees(
        webSocket,
        signer as Signer,
        poolControllerAddr,
        assets as ERC20Wei,
        (await (signer as Signer).getAddress()) as EthAddr,
        poolAddr,
        chainConfigurationName
      )
      dispatch(poolActions.withdrawFeesSuccess(props))
    } catch (e: any) {
      dispatch(poolActions.withdrawFeesFail(props))
      await dispatchError(dispatch, e, activity, 1018)
    }
  }
export const withdrawFees = async (
  webSocket: WebSocket | undefined,
  poolAdminSigner: Signer,
  poolControllerAddr: EthAddr,
  usdcInWei: ERC20Wei,
  feeCollectorAddr: EthAddr,
  poolAddr: EthAddr,
  chainConfigurationName: string
): Promise<void> => {
  logOT.debug('withdrawFees')

  const uuid = txUUID()
  webSocket?.send(wsServerActionPoolTXRequest(ActivityEnum.WITHDRAW_FEES, poolAddr, uuid, chainConfigurationName))

  const poolControllerContract = new Contract(poolControllerAddr, PoolControllerAbi, poolAdminSigner)

  const tx = await poolControllerContract.withdrawFeeVault(usdcInWei, feeCollectorAddr)

  webSocket?.send(
    wsServerActionPoolTX(ActivityEnum.WITHDRAW_FEES, poolAddr, uuid, tx.hash as TxHash, chainConfigurationName)
  )
  await tx.wait(1)

  logOT.debug('tx', tx)
}
